<template>
	<div id="apllyServer">
		<div v-title>申请售后</div>
		<div class="container">
			<div class="check-order" @click="showParentDia">
				<span v-if="!childObj.orderId" class="check-title">请选择订单</span>
				<div class="order-info" v-else>
					<p>{{childObj.productName}}</p>
					<p class="receive-info">收花日期：{{childObj.receiveDate}}</p>
				</div>
				<span class="to-check"></span>
			</div>
			<div class="problem-box problem-mg">
				<div class="problem-title">
					售后类型 :</span>
				</div>
				<div class="tab-box clearfix" >
					<div :class="{'after-tab':true,'active':item.checked}"  v-for="item in afterTypes" @click="chkSalesTab(item)">
						{{item.label}}<span class="sales-return" v-if="item.label=='退货退款'">（仅支持非生鲜收货7天内）</span>
					</div>
				</div>
			</div>
			<div class="problem-box">
				<div class="problem-title">
					问题类型 :&nbsp;<span>(可多选)</span>
				</div>
				<div class="tab-box clearfix" >
					<div :class="{'problem-tab':true,'active':item.checked}" v-for="item in tabs" @click="chkTab(item)">{{item.label}}</div>
				</div>
			</div>
			<div class="content-box">
				<textarea placeholder="请输入问题描述，最多300字（选填）" v-model="content" maxlength="300"></textarea>
				<div class="img-container">
					<div class="img-box" id="imgboxid">
						<div class="img-item" v-for="(item,index) in imgArr">
							<span class="del-img" @click="delImg(index)">
								<img src="https://misc.reflower.com.cn/images/customer/delete.png" />
							</span>
							<img :src="item" @click="showBig(item)" />
						</div>
					</div>
					<input type='file' id="imgInp" @change="upimg($event)" name="multipartFiles" accept="image/*" style="display: none;" />
					<img id="blah0" v-if="imgArr.length<3" class="add-img" @click="checkipt()" width="100" src="https://misc.reflower.com.cn/images/customer/camera.png" alt="显示您上传的商品图片" />
				</div>
			</div>
			<div class="submit-box">
				<div class="submit" @click="present" v-if="isSubIng">提交</div>
				<div class="submit" v-else>提交中...</div>
			</div>
		</div>
		<!--父订单-->
		<div class="parent-dia" v-show="parentDia">
			<div class="parent-content">
				<div class="parent-title">
					选择订单<span class="close-more" @click="closeMore"></span>
				</div>
				<scroller :on-infinite="infinite" :on-refresh="refresh" ref="myscroller" noDataText="我是有底线的" style='padding-top: 1.066666rem;'>
					<div class="order-item" v-for="item in parentsList" @click="chkParentOrder(item)">
						<p class="order-out">{{item.outOrderId}} <span style="float: right;">{{item.receiveDate}}</span></p>
						<p class="order-title">{{item.productName}}</p>
						<p class="user-infor"><span>{{item.receiver}}</span><span>{{item.address}}</span></p>
						<span :class="{'check-parent':true, 'parent-checked':item.checked}"></span>
					</div>
					<div class="no-data">{{noData}}</div>
				</scroller>
			</div>
		</div>
		<div class="child-content" v-show="childDia">
			<div class="child-title">
				<span class="back-parent" @click="backPre"></span> 选择订单
				<span class="close-more" @click="closeChild"></span>
			</div>
			<div class="order-list">
				<div class="order-item" v-for="item in checkObj.periods" @click="chkChildOrder(item)">
					<p class="order-title">第{{item.periodsNum}}期</p>
					<p class="user-infor"><span>收花日期:&nbsp;&nbsp;</span><span>{{item.receiveTime}}</span>&nbsp;&nbsp;<span>{{item.receiveWeek}}</span></p>
					<span :class="{'check-parent':true, 'parent-checked':item.checked}"></span>
				</div>
			</div>

		</div>
		<div class="explain-wrap" v-show="showExplain" @click="hideBig">
			<div class="content-boxb">
				<img v-if="transImg!=''" :src="transImg" />
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import VueScroller from 'vue-scroller'
	import '../../static/lib/layer.js'
	Vue.use(VueScroller)
	export default {
		data() {
			return {
				tabs: [{
					label: '质量问题',
					checked: false
				},  {
					label: '错发',
					checked: false
				}, {
					label: '漏发',
					checked: false
				}, {
					label: '美观问题',
					checked: false
				}, {
					label: '意见建议',
					checked: false
				},{
					label: '（非生鲜）七天无理由退货',
					checked: false
				},{
					label: '其他',
					checked: false
				}],
				afterTypes:[{
					label: '仅退款',
					checked: false,
					type:2
				},{
					label: '退货退款',
					checked: false,
					type:1
				},{
					label: '其他',
					checked: false,
					type:0
				}],
				offset: 0,
				limit: 10,
				totalNum: 0,
				typeList: [],
				parentDia: false,
				childDia: false,
				parentsList: [],
				tempList: [],
				noData: '',
				checkObj: {},
				childObj: {},
				imgArr: [],
				content: '',
				showExplain: false,
				transImg: '',
				isSubIng: true,
				user: {},
				afterType:""

			}
		},
		created() {
			// this.chkLogin();
			this.getUserInfo();
//			this.getOrderList()
		},
		methods: {
			//问题类型
			chkTab: function(val) {
				this.typeList = [];
				if(val.checked) {
					val.checked = false;
				} else {
					val.checked = true;
				}
				for(let temp of this.tabs) {
					if(temp.checked) {
						this.typeList.push(temp.label)
					}
				};
				console.log(this.typeList)
			},
			//售后类型选择
			chkSalesTab(item) {
				this.afterTypes.map(item1=>{
					item1.checked= false
				})
				item.checked=true
				this.afterType=item.type
			},
			showParentDia: function() {

				for(let temp of this.parentsList) {
					temp.checked = false;
//					for(let temp1 of temp.periods) {
//						temp1.checked = false;
//					}
				};

				let hdu = this.getCookie('hdu');
				if(hdu == "" || hdu==undefined){
					return
				}
				let param = {
					pageSize: this.limit,
					userId: hdu,
					pageNumber: 1,
					mobile: this.user.mobile,
				};
				this.http({
					url: this.ordersUrl,
					method: 'post',
					data: param

				}).then(res => {
					if(res.data.httpCode == 200) {
						var list = res.data.data;
						if(list.length > 0) {
							this.parentDia = true;
						} else {
							this.popUp('没有可选的订单')
						}
					}
				}).catch(err => {

				})
			},

			closeMore: function() {
				this.parentDia = false;
			},

			//选择父订单
			chkParentOrder: function(val) {
				this.checkObj = {};
				let _this = this;
				for(let temp of this.parentsList) {
					temp.checked = false;
				}
				val.checked = true;
				this.childObj = val;
				this.parentDia = false;
        if(val.orderWay != '10'){
          layer.open({
          	content: '亲亲，识别到您的订单非商城下单订单，为了更快速的为您解决问题，建议优先联系下单渠道客服为您处理~',
          	skin: 'msg',
          	time: 10 //2秒后自动关闭
          });

        }
//				this.checkObj = val;
//				setTimeout(() => {
//					_this.childDia = true;
//				}, 500)

			},

			//选择自订单
			chkChildOrder: function(val) {
				this.checkObj.periods.forEach(item => {
					item.checked = false;
				});
				val.checked = true;

				this.parentDia = false;
				this.childDia = false;
			},

			closeChild: function() {
				this.childDia = false;
				this.parentDia = false;

			},

			backPre: function() {
				this.childDia = false;
				this.childObj = {};
			},

			getOrderList: function(offset, done) {
				let hdu = this.getCookie('hdu');
				let param = {
					pageSize: this.limit,
					userId: hdu,
					mobile: this.user.mobile,
					pageNumber: this.offset,
				};
				this.http({
					url: this.ordersUrl,
					method: 'post',
					data: param

				}).then(res => {
					if(res.data.httpCode == 200) {
						var list = res.data.data;
						let list1 = [];
						if(list.length > 0) {
							console.log(list,'list')
							for(let temp of list) {
								temp.checked = false;
//								for(let temp1 of temp.periods) {
//									temp1.checked = false;
//								}
								this.parentsList.push(temp);
							}
							console.log(this.parentsList,'this.parentsList')
						} else {
							if(this.parentsList.length > 0) {
								var _this = this;
								_this.noData = "-没有更多数据了-"
								setTimeout(() => {
									//没有数据了 执行 finishInfinite(2)
									_this.$refs.myscroller.finishInfinite(2);
								}, 10)
							} else {

							}
							return
						}
						//						this.parentsList = list1;
						this.$refs.myscroller.finishPullToRefresh();
						if(res.data.httpCode == 200) {
							done();
						}
					}
				}).catch(err => {

				})
			},

			infinite: function(done) {
				this.offset++;
				this.getOrderList(this.offset, done);
			},

			refresh(done) { //这是向下滑动的时候请求最新的数据
				this.parentsList = [];
				this.offset = 1;
				this.getOrderList(1, done)
			},

			upimg: function(event) {
				console.log(event.target.files)
				var _this = this;
				var imgurl = this.upload;
				var iamges = new Array();
				var file1 = event.target.files;
				for(var i = 0; i < file1.length; i++) {
					var file = file1[i];
					(function(file, i) {
						var reader = new FileReader();
						iamges[i] = new Image();
						reader.readAsDataURL(file);
						reader.onloadend = function(e) {
							var ace = this.result;
							iamges[i].src = ace;
							console.log(ace, 'ace')
						}
						let loStr = 'https://misc.reflower.com.cn/images/customer/uploading.png';
						_this.imgArr.splice(i, 0, loStr);
						iamges[i].onload = function() {
							var w = iamges[i].width;
							var h = iamges[i].height;
							var ratio, multiplier;
							if(w < 720 && h < 720) { //小于100K 的不压缩
								multiplier = 1;
								ratio = 0.8;
							} else {
								ratio = 1;
								if(w < 720 && h >= 720) {
									multiplier = 720 / h;
								} else if(w >= 720 && h < 720) {
									multiplier = 720 / w;
								} else {
									multiplier = 720 / Math.max(w, h);
									ratio = 0.8;
								}
							}
							var imageData = _this.compress(iamges[i], w * multiplier, h * multiplier, ratio);
							var formData = new FormData();
							formData.append("imageData", imageData);
							$.ajax({
								url: imgurl,
								type: 'POST',
								cache: false,
								data: formData,
								async: false,
								processData: false,
								contentType: false,
								dataType: "json",
								xhrFields: {
									withCredentials: true
								},
								crossDomain: true,
								success: function(msg) {
									if(msg.code == 1) {
										var str = 'http://img.reflower.com.cn/' + msg.data;
										if(_this.imgArr.length <= 3) {
											_this.imgArr.splice(i, 1);
											_this.imgArr.push(str);
										} else {
											return
										}
									} else {
										_this.popUp(msg.desc)
									}
								}
							});
						}
					})(file, i)

				}
			},

			//BIG
			showBig: function(item) {
				this.showExplain = true;
				this.transImg = item;
			},

			hideBig: function() {
				this.showExplain = false;
			},

			checkipt: function() {
				$('#imgInp').trigger("click");
			},

			//刪除圖片
			delImg: function(index) {
				this.imgArr.splice(index, 1)
			},

			present: function() {
				let arr = new Array();
				let load = 'https://misc.reflower.com.cn/images/customer/uploading.png';
				this.imgArr.map(item => {
					if(item != load) {
						arr.push(item)
					}
					return item;
				});


				console.log(arr, 'arr');
				let param = {
					orderId: this.childObj.orderId,
					problem_type: this.typeList.join(','),
					problemContent: this.content,
					images: JSON.stringify(arr),
					afterType: this.afterType,
					openid: this.user.openid
				};
				if(!this.childObj.orderId) {
					this.popUp('请选择订单');
					return
				}else if(this.afterType == "" && this.afterType != 0 ){
          console.log(this.afterType,'this.afterType')
					this.popUp('请选择售后类型');
					return
				} else if(this.typeList.length == 0) {
					this.popUp('请选择问题类型');
					return
				}
        if(this.typeList.indexOf('质量问题') != -1 || this.typeList.indexOf('错发') != -1 || this.typeList.indexOf('漏发') != -1 || this.typeList.indexOf('（非生鲜）七天无理由退货') != -1){
          if(arr.length == 0){
            this.popUp('请上传图片！')
            return
          }
          if(this.content == ""){
            this.popUp('请填写描述！')
            return
          }
        }
					this.isSubIng = false;
					this.http({
						url: this.createForm,
						method: 'post',
						data: param
					}).then(res => {
						this.isSubIng = true;
						if(res.data.httpCode == 200) {
							this.$router.push({
								path: 'subSuccess',
							})
						} else {
							this.popUp(res.data.msg)
						}

					})

			},

			//tost
			popUp: function(content) {
				layer.open({
					content: content,
					skin: 'msg',
					time: 4 //2秒后自动关闭
				});
			},

			getCookie: function(name) { //获取cookie
				var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
				if(arr = document.cookie.match(reg)) {
					var data = unescape(arr[2]);
					return data;
				} else {
					return '';
				}
			},

			delCookie: function(name) { //删除cookie
				var exp = new Date();
				exp.setTime(exp.getTime() - 1);
				var cval = this.getCookie(name);
				console.log(this.getCookie(name))
				document.cookie = name + "=" + cval + ";path=/;domain=reflower.com.cn;expires=" + exp.toGMTString() + "";
				console.log(document.cookie)
			},

			compress: function(img, width, height, ratio) {
				var canvas, ctx, img64;
				canvas = document.createElement('canvas');
				canvas.width = width;
				canvas.height = height;
				ctx = canvas.getContext("2d");
				ctx.drawImage(img, 0, 0, width, height);
				img64 = canvas.toDataURL("image/jpeg", ratio);
				return img64;
			},

			chkLogin: function() {
				let uid = this.getCookie('hdu');
				let hdt = this.getCookie('hdt');
				let ua = navigator.userAgent.toLowerCase();
				let loginurl = this.loginurl;
				let wechaturl = this.wechaturl;
				let alipayurl = this.alipayurl;
				let alipayoauth2url = 'https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2017021505685120&redirect_uri=';
				let oauth2url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx05d6a1410a2236e1&redirect_uri=';
        // let oauth2url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxaa2aa6cc330cd7bf&redirect_uri=';
				if(!!!uid || !!!hdt) {
					var currenturl = window.location.href;
					if(currenturl.indexOf('?') < 0) {
						currenturl += "?";
					} else {
						currenturl += "&";
					}
					if(ua.match(/MicroMessenger/i) == "micromessenger") {
						//   	console.log("wechaturl: "+wechaturl + "||| currenturl: "+currenturl );
						var redirectUrl = encodeURIComponent(wechaturl + currenturl);
						//   	console.log("redirectUrl"+redirectUrl);
						var resultUrl = oauth2url + redirectUrl + "&response_type=code&scope=snsapi_base&state=login#wechat_redirect";
						window.location.href = resultUrl;
					} else if(ua.indexOf("alipay") >= 0) {
						var redirectUrl = encodeURIComponent(alipayurl + currenturl);
						var resultUrl = alipayoauth2url + redirectUrl + "&scope=auth_user,auth_zhima";
						window.location.href = resultUrl;
					} else {
						window.location.href = loginurl + currenturl;
					}

				}
			},

			//获取用户信息
			getUserInfo: function() {
				let _this = this;
				let uid = this.getCookie('hdu');
				let hdt = this.getCookie('hdt');
				$.ajax({
					url: _this.userInfo,
					type: 'post',
					async: false,
					type: 'post',
					xhrFields: {
						withCredentials: true
					},
					contentType: "application/json",
					crossDomain: true,
					dataType: "json",
					success: function(res) {
						if(res.code == 2000) {
							_this.user = res.data
						} else if(res.code == 1010) {
							_this.delCookie('hdu');
							_this.delCookie('hdt');
							if(!uid || !hdt) {
								_this.chkLogin();
							}

						} else {
							_this.popUp(res.msg)
						}
					}
				});
			}

		}
	}
</script>

<style scoped>
	.check-order {
		margin: 0.32rem 0.213333rem;
		height: 1.6rem;
		display: flex;
		display: -webkit-flex;
		align-items: center;
		-webkit-align-items: center;
		-webkit-justify-content: space-between;
		justify-content: space-between;
		font-size: 0.373333rem;
		padding: 0 0.4rem 0 0.4rem;
		background-color: #ffffff;
		margin-bottom: 0.213333rem;
	}
	.submit-box{
		padding: 0 0.213333rem;
		width: 100%;
		height: 2rem;
		position: fixed;
		bottom: 0;
		left: 0;
		background: #f4f4f4;
		opacity: 1;
	}
	.submit {
		font-size: 0.48rem;
		color: #FFFFFF;
		height: 1.306666rem;
		line-height: 1.306666rem;
		background-color: #262628;
		border-radius: 0.16rem;
	}

	.order-info p {
		text-align: left;
		font-size: 0.373333rem;
		width: 9rem;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.order-info .receive-info {
		color: #999999;
		font-size: 0.32rem;
		margin-top: 0.213333rem;
	}

	.to-check {
		width: 0.213333rem;
		height: 0.373333rem;
		background: url(https://misc.reflower.com.cn/images/ccb/gou.png)no-repeat right center;
	}

	.problem-box {
		margin: 0 0.213333rem;
		/*height: 3.493333rem;*/
		background-color: #FFFFFF;
		padding-left: 0.4rem;
		padding-bottom: 0.56rem;
	}
	.problem-mg{
		margin-bottom: 0.32rem;
	}
	.problem-box .problem-title {
		padding: 0.32rem 0 0.213333rem 0;
		font-size: 0.373333rem;
		text-align: left;
	}

	.problem-box .problem-title span {
		color: #cccccc;
	}

	.problem-box .tab-box .problem-tab {

		font-size: 0.266666rem;
		color: #999999;
		padding: 0.16rem 0.346666rem;
		float: left;
		border: 1px solid #DDDDDD;
		margin-right: 0.266666rem;
		margin: 0.106666rem 0.266666rem 0.106666rem 0;
		border-radius: 0.053333rem;
	}
	.problem-box .tab-box .after-tab {
		box-sizing: border-box;
		margin-bottom: 0.266666rem;
		padding: 0.16rem 0.133333rem;
		float: left;
		min-width: 4.133333rem;
		height: 0.8rem;
		font-size: 0.266666rem;
		color: #999999;
		border: 1px solid #DDDDDD;
		background: #F5F5F5;
		border-radius: 0.08rem;
	}
	.problem-box .tab-box .after-tab:first-of-type{
		margin-right: 0.253333rem;
	}
	.sales-return{
		font-size: 0.266666rem;
		color: red;
	}

	.active {
		background-color: #AED000!important;
		color: #fff!important;
		border: 1px solid #C4D275!important;
	}

	.content-box {
		margin: 0 0.213333rem 2.4rem 0.213333rem;
		height: 5.6rem;
		background-color: #FFFFFF;
		margin-top: 0.213333rem;
		border-top: 1px solid #DDDDDD;
		border-bottom: 1px solid #DDDDDD;
		padding: 0.4rem 0.4rem;
		padding-bottom: 0;
	}

	.content-box textarea {
		display: inline-block;
		resize: none;
		border: none;
		outline: none;
		width: 100%;
		font-size: 0.373333rem;
		height: 2.933333rem;
		line-height: 0.533333rem;
	}

	.content-box .add-img {
		display: block;
		width: 1.6rem;
		height: 1.6rem;
	}

	.parent-dia {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 1000;
	}

	.parent-dia::before {
		content: '';
		z-index: 0;
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: #000;
		opacity: 0.6;
	}

	.parent-dia .parent-content {
		opacity: 1;
		width: 100%;
		height: 8rem;
		background-color: #FFFFFF;
		z-index: 1001;
		position: absolute;
		left: 0;
		bottom: 0;
	}

	.parent-dia .parent-content .parent-title {
		height: 1.066666rem;
		line-height: 1.066666rem;
		font-size: 0.4rem;
		border-bottom: 1px solid #DDDDDD;
		position: relative;
		opacity: 1;
		z-index: 3000;
		background-color: #FFFFFF;
	}

	.parent-dia .parent-content .parent-title .close-more {
		display: block;
		position: absolute;
		right: 0.426666rem;
		top: 0.426666rem;
		width: 0.346666rem;
		height: 0.346666rem;
		background: url(https://misc.reflower.com.cn/images/apply/apply_close.png)no-repeat center center;
	}

	.order-list {
		height: 6.88rem;
		z-index: 3500;
		overflow-y: scroll;
	}

	.order-item {
		height: 2.3rem;
		border-bottom: 1px solid #DDDDDD;
		padding: 0.266666rem 0.4rem 0 0.4rem;
		text-align: left;
		position: relative;
	}

	.order-item .order-title {
		font-size: 0.373333rem;
		height: 0.533333rem;
		margin-bottom: 0.16rem;
		width: 9.2rem;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.order-item .order-out{
		font-size: 0.28rem;
		height: 0.533333rem;
		/*margin-bottom: 0.16rem;*/
		width: 9.2rem;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.order-item .user-infor {
		font-size: 0.346666rem;
		color: #999999;
		height: 0.506666rem;
	}

	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	.no-data {
		height: 1.333333rem;
		width: 100%;
		line-height: 1.333333rem;
		z-index: 0;
		font-size: 0.4rem;
		text-align: center;
		color: #999999;
	}

	.pull-to-refresh-layer {
		margin-top: -20px !important;
	}

	.check-parent {
		display: inline-block;
		position: absolute;
		width: 0.533333rem;
		height: 0.533333rem;
		right: 0.426666rem;
		top: 0.586666rem;
	}

	.parent-checked {
		background: url('https://misc.reflower.com.cn/images/apply/apply_y.png')no-repeat center center;
		background-size: 0.533333rem 0.533333rem;
	}

	.child-content {
		opacity: 1;
		width: 100%;
		height: 8rem;
		background-color: #FFFFFF;
		z-index: 3001;
		position: absolute;
		left: 0;
		bottom: 0;
		padding-bottom: 0.533333rem;
		overflow-y: scroll;
	}

	.child-content .child-title {
		height: 1.066666rem;
		line-height: 1.066666rem;
		font-size: 0.4rem;
		border-bottom: 1px solid #DDDDDD;
		position: relative;
		opacity: 1;
		z-index: 3000;
		background-color: #FFFFFF;
	}

	.child-content .child-title .back-parent {
		width: 0.213333rem;
		height: 0.373333rem;
		background: url(https://misc.reflower.com.cn/images/ccb/gou.png)no-repeat right center;
		position: absolute;
		left: 0.56rem;
		top: 0.373333rem;
		transform: rotate(180deg);
		-ms-transform: rotate(180deg);
		-webkit-transform: rotate(180deg);
		-moz-transform: rotate(180deg);
		-moz-transform: rotate(180deg);
	}

	.child-content .child-title .close-more {
		display: block;
		position: absolute;
		right: 0.426666rem;
		top: 0.426666rem;
		width: 0.346666rem;
		height: 0.346666rem;
		background: url(https://misc.reflower.com.cn/images/apply/apply_close.png)no-repeat center center;
	}

	.img-box {
		/*display: inline-block;*/
	}

	.img-box .img-item {
		float: left;
		width: 1.6rem;
		height: 1.6rem;
		position: relative;
		margin-right: 0.32rem;
	}

	.img-box .img-item img {
		display: block;
		width: 1.6rem;
		height: 1.6rem;
	}

	.img-box .img-item .del-img {
		display: inline-block;
		height: 0.453333rem;
		height: 0.453333rem;
		position: absolute;
		right: -0.226666rem;
		top: -0.226666rem;
	}

	.img-box .img-item .del-img img {
		width: 0.453333rem;
		height: 0.453333rem;
	}

	input {
		font-size: 0;
		outline: none;
		border: none;
		display: none;
		opacity: 0;
		background-color: #FFFFFF;
	}
	/*input::-webkit-file-upload-button {
        background: url(../../static/img/camera.png)no-repeat center center;
        background-size: 100% 100%;
        color: #333;
        border: 0;
        padding: 40px 100px;
        border-radius: 5px;
        font-size: 12px;
        box-shadow: 1px 1px 5px rgba(0,0,0,.1), 0 0 10px rgba(0,0,0,.12);
        display: block;
		width: 1.6rem;
		height: 1.6rem;

    }*/

	textarea::-webkit-input-placeholder {
		/* WebKit browsers */
		color: #999;
	}

	textarea::-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: #999;
	}

	.explain-wrap {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 1000;
	}

	.explain-wrap::before {
		content: '';
		z-index: 0;
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: #000;
		opacity: 0.7;
	}

	.content-boxb {
		z-index: 3001;
		width: 8.8rem;
		/*height: 12.666666rem;*/
		border-radius: 0.106666rem;
		position: absolute;
		background-color: #fff;
		left: 50%;
		top: 50%;
		-webkit-transform: translate(-50%, -50%);
		-o-transform: translate(-50%, -50%);
		-moz-transform: translate(-50%, -50%);
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
	}

	.content-boxb img {
		display: block;
		width: 100%;
		height: 100%;
	}
	.clearfix:after {
    content: ".";
    display: block;
    clear: both;
    visibility: hidden;
    font-size: 0;
}
</style>



// WEBPACK FOOTER //
// src/path/applyServer.vue